import { Card, CardContent } from "@/components/ui/card";
import { BinaryRating } from "@/components/doctor-training/binary-rating";
import { SingleBinaryRating } from "@/components/doctor-training/single-binary-rating";

export const BinaryRatings = ({
  binaryRatings,
  bg = "bg-white",
  single = false,
}: {
  binaryRatings: DoctorTrainingReportSummaryBinaryRating[];
  bg?: string;
  single?: boolean;
}) => {
  const Rating = single ? SingleBinaryRating : BinaryRating;
  return (
    <Card className={`${bg}`}>
      <CardContent className={"flex flex-col gap-4"}>
        {binaryRatings.map(({ up, down, title }) => (
          <Rating key={title} title={title} down={down} up={up} />
        ))}
      </CardContent>
    </Card>
  );
};
